var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSignOut(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 20 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M0 2.94v10.12C0 14.68 1.27 16 2.826 16h7.862c1.557 0 2.826-1.32 2.826-2.94v-1.64c0-.502-.391-.909-.875-.909-.483 0-.874.407-.874.91v1.639c0 .618-.487 1.124-1.081 1.124H2.826c-.594 0-1.08-.506-1.08-1.124V2.94c0-.618.486-1.124 1.08-1.124h7.862c.594 0 1.08.506 1.08 1.124v1.64c0 .502.392.909.875.909s.875-.407.875-.91V2.94c0-1.62-1.27-2.94-2.826-2.94H2.826C1.27 0 0 1.316 0 2.94Z",
    clipRule: "evenodd",
    fill: "#ffffff80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.456 12.06a.853.853 0 0 1-1.236.002.926.926 0 0 1 0-1.282l.002-.002 1.796-1.868H8.96c-.484 0-.875-.407-.875-.91 0-.503.391-.91.875-.91h8.062l-1.8-1.872a.931.931 0 0 1 0-1.282.847.847 0 0 1 1.234 0l3.288 3.42a.932.932 0 0 1 0 1.283l-3.288 3.421Z",
    clipRule: "evenodd",
    fill: "#ffffff80"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/sign-out.1e8e0f1415977601233a50018878bc39.svg";
export { ForwardRef as ReactComponent };